import BaseApi from "../base";

export default class Comments extends BaseApi {

}

